import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';

import { useCallback } from 'react';

import { BankOperation } from 'types/embedded/bankOperation';

export function useBankOperationEditable() {
  const checkBankOperationEditable = useCallback(
    (record: BankOperation) =>
      record?.status?.value === BankOperationStatusesNew.Created ||
      record?.status?.value === BankOperationStatusesNew.Rejected,
    [],
  );

  return { checkBankOperationEditable };
}
